import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-monitoring-search',
  templateUrl: './device-monitoring-search.component.html',
  styleUrls: ['./device-monitoring-search.component.scss'],
})
export class DeviceMonitoringSearchComponent {
  @Input() isLoading = false;
  @Output() clickSearched = new EventEmitter<SearchParameters>();

  // defaulting dates to today and 2 days ago
  startDate: string = getDefaultDate(
    new Date(new Date().getTime() - 172800000),
  );
  endDate: string = getDefaultDate(new Date());
  serialNumbers = '';
  shareableLink = '';
  isTimelineSearched = false;

  sessionStorageKey = 'dvcctrl-monitor-search';

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const previousState = this.getStoredParams();
    if (previousState) {
      this.serialNumbers = previousState.serialNumbers.join(',');
    }

    const params = this.route.snapshot.queryParams;
    if (params['serialNumbers']) {
      this.serialNumbers = params['serialNumbers'];
      this.startDate = getDefaultDate(new Date(params['startDate']));
      this.endDate = getDefaultDate(new Date(params['endDate']));
    }

    if (this.serialNumbers && this.startDate && this.endDate) {
      this.searchTimeline();
    }
  }

  navigateURL() {
    return this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        startDate: new Date(this.startDate).toISOString(),
        endDate: new Date(this.endDate).toISOString(),
        serialNumbers: this.serialNumbers,
      },
    });
  }

  shareLink() {
    this.toastr.info('Copied link to your clipboard.');

    navigator.clipboard.writeText(window.location.href);
  }

  searchTimeline() {
    if (!this.serialNumbers.length) {
      this.toastr.warning(`Serial numbers are required.`);
      return;
    }

    if (!this.startDate.length) {
      this.toastr.warning(`A start date is required.`);
      return;
    }

    if (!this.endDate.length) {
      this.toastr.warning(`A end date is required.`);
      return;
    }

    this.parseSerialNumbers();
    this.navigateURL();

    const serialNumbers = this.serialNumbers
      .split(' ')
      .map((s) => s.trim())
      .filter((s) => s != '');
    const searchParams = {
      start: this.startDate,
      end: this.endDate,
      serialNumbers,
    };
    this.setStoredParams(searchParams);
    this.isLoading = true;
    this.clickSearched.emit(searchParams);
    this.isTimelineSearched = true;
  }

  private getStoredParams(): SearchParameters | undefined {
    const previousState = localStorage.getItem(this.sessionStorageKey);
    if (!previousState) {
      return undefined;
    }

    return JSON.parse(previousState);
  }

  private setStoredParams(obj: SearchParameters) {
    localStorage.setItem(this.sessionStorageKey, JSON.stringify(obj));
  }
  private parseSerialNumbers(): void {
    if (this.serialNumbers.trim().endsWith(',')) {
      this.serialNumbers = this.serialNumbers.trim().slice(0, -1);
    }

    this.serialNumbers = this.serialNumbers.replace(/[,\n]/g, ' ');
  }
}

export const getDefaultDate = (date: Date) => {
  const fullYear = date.getFullYear().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${fullYear}-${month}-${day}T${hours}:${minutes}`;
};

export interface SearchParameters {
  start: string;
  end: string;
  serialNumbers: string[];
}
